module.exports = __webpack_public_path__ + "img/bystyle.e6b6a10.jpg";